module.exports = __webpack_public_path__ + "img/icb-del-elite-e@2x.8082506e.png";